import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Users, Database, Globe } from 'lucide-react';
import '../../styles/pages/terms-of-service.css';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="legal-page terms-of-service-page">
      {/* Header */}
      <div className="topbar">
        <div className="topbar-inner">
          <div className="topbar-row">
            <a
              href="https://smarteco.ai/"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
            >
              <img
                src={`${process.env.PUBLIC_URL}/SVGIcons/SmartecoLogo.svg`}
                alt="Logo"
                className="logo smarteco-logo"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="main">
        <div className="card">
          <div className="title-block">
            <h1 className="title">Terms of Service</h1>
            <p className="subtitle">Last updated: January 2025</p>
          </div>

          <section className="section">
            <h2>
              <Shield />
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing and using SmartEco Dashboard (&quot;Service&quot;), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="section">
            <h2>
              <Users />
              2. Description of Service
            </h2>
            <p>
              SmartEco Dashboard provides air quality monitoring and device management services. The Service includes:
            </p>
            <ul className="dot">
              <li>Real-time air quality data monitoring</li>
              <li>Device management and configuration</li>
              <li>Data visualization and analytics</li>
              <li>Alert and notification systems</li>
              <li>API access for third-party integrations</li>
            </ul>
          </section>

          <section className="section">
            <h2>3. User Accounts</h2>
            <p>
              To access certain features of the Service, you must create an account. You are responsible for:
            </p>
            <ul className="dot">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and complete information</li>
              <li>Notifying us immediately of any unauthorized use</li>
            </ul>
          </section>

          <section className="section">
            <h2>4. Acceptable Use</h2>
            <p>You agree not to use the Service to:</p>
            <ul className="dot">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe upon the rights of others</li>
              <li>Transmit harmful, offensive, or inappropriate content</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Interfere with or disrupt the Service</li>
              <li>Use the Service for commercial purposes without authorization</li>
            </ul>
          </section>

          <section className="section">
            <h2>
              <Database />
              5. Data and Privacy
            </h2>
            <p>
              Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices regarding the collection and use of your information.
            </p>
          </section>

          <section className="section">
            <h2>6. Intellectual Property</h2>
            <p>
              The Service and its original content, features, and functionality are and will remain the exclusive property of SmartEco and its licensors. The Service is protected by copyright, trademark, and other laws.
            </p>
          </section>

          <section className="section">
            <h2>7. Termination</h2>
            <p>
              We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.
            </p>
          </section>

          <section className="section">
            <h2>8. Limitation of Liability</h2>
            <p>
              In no event shall SmartEco, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.
            </p>
          </section>

          <section className="section">
            <h2>9. Disclaimer</h2>
            <p>
              The information on this Service is provided on an &quot;as is&quot; basis. SmartEco makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
          </section>

          <section className="section">
            <h2>
              <Globe className="primary" />
              10. Governing Law
            </h2>
            <p>
              These Terms shall be interpreted and governed by the laws of the United Arab Emirates, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="section">
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.
            </p>
          </section>

          <section className="section">
            <h2>12. Contact Information</h2>
            <p>If you have any questions about these Terms of Service, please contact us at:</p>
            <div className="contact-block">
              <p>
                <strong>Email:</strong> <span className="email">smartecosupport@ispatialtec.com</span><br />
                <strong>Address:</strong> iSpatial Techno Solutions LLC, Abu Dhabi, UAE<br />
                <strong>Phone:</strong> +971 50 582 5503
              </p>
            </div>
          </section>

          <div className="page-footer">
            <div className="page-footer-row">
              <Link to="/privacy" className="page-footer-link">
                View Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
